"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const erc721_json_1 = __importDefault(require("./abis/erc721.json"));
class ERC721 {
    constructor(account, token721, multicall, swapContract) {
        this.swapMulticall = multicall;
        this.account = account;
        this.token721 = token721;
        this.contract = swapContract.useContract(token721.address, erc721_json_1.default, true);
    }
    /**
     * 获取指定钱包地址所有该721通证
     *
     * @param {string} owner 钱包地址
     * @param {number} total 该钱包地址拥有的总数
     * @returns {Promise<TokenIdOwner[]>}
     * @memberof ERC721
     */
    async allTokensOfOwner(owner, total) {
        // @ts-ignore
        const indexs = Array.from({ length: total }, (v, i) => [owner, i]);
        const results = await this.swapMulticall.useSingleContractMultipleData(this.contract, "tokenOfOwnerByIndex", indexs);
        const tokenIds = results
            .filter((result) => { var _a; return result.valid && ((_a = result.result) === null || _a === void 0 ? void 0 : _a.length) === 1; })
            .map((result) => result.result && result.result[0].toNumber());
        return tokenIds.map((id) => {
            return {
                token: this.token721,
                owner,
                tokenId: id
            };
        });
    }
    /**
     * 获取所有该721通证
     *
     * @param {number} total 该721通证发行量
     * @returns {Promise<TokenIdOwner[]>}
     * @memberof ERC721
     */
    async allTokens(total) {
        // @ts-ignore
        const indexs = Array.from({ length: total }, (v, i) => [i]);
        const results = await this.swapMulticall.useSingleContractMultipleData(this.contract, "tokenByIndex", indexs);
        const tokenIds = results
            .filter((result) => { var _a; return result.valid && ((_a = result.result) === null || _a === void 0 ? void 0 : _a.length) === 1; })
            .map((result) => result.result && result.result[0].toNumber());
        // @ts-ignore
        const inputs = Array.from({ length: tokenIds.length }, (v, i) => [tokenIds[i]]);
        const ownerResults = await this.swapMulticall.useSingleContractMultipleData(this.contract, "ownerOf", inputs);
        const owners = ownerResults
            .filter((result) => { var _a; return result.valid && ((_a = result.result) === null || _a === void 0 ? void 0 : _a.length) === 1; })
            .map((result) => result.result && result.result[0]);
        return owners.map((owner, i) => {
            return {
                tokenId: tokenIds[i],
                owner,
                token: this.token721
            };
        });
    }
    async admin() {
        var _a;
        const res = await this.swapMulticall.useSingleCallResult(this.contract, "admin");
        return (_a = res === null || res === void 0 ? void 0 : res.result) === null || _a === void 0 ? void 0 : _a[0];
    }
    async approve(to, tokenId) {
        var _a;
        const result = await ((_a = this.contract) === null || _a === void 0 ? void 0 : _a.approve(to, tokenId, {
            from: this.account
        }));
        return result;
    }
    /**
     * 获取指定钱包地址721拥有总数
     *
     * @param {string} owner
     * @returns {Promise<number>}
     * @memberof ERC721
     */
    async balanceOf(owner) {
        var _a;
        const res = await this.swapMulticall.useSingleCallResult(this.contract, "balanceOf", [owner]);
        return (_a = res === null || res === void 0 ? void 0 : res.result) === null || _a === void 0 ? void 0 : _a[0].toNumber();
    }
    /**
     * 判断tokenId是否授权
     *
     * @param {number} tokenId
     * @param {string} contract 合约地址
     * @returns {Promise<boolean>}
     * @memberof ERC721
     */
    async isApproved(tokenId, contract) {
        const approved = await this.getApproved(tokenId);
        return (approved === null || approved === void 0 ? void 0 : approved.toLowerCase()) === contract.toLowerCase();
    }
    /**
     * 获取授权地址
     *
     * @param {number} tokenId
     * @returns {Promise<string>}
     * @memberof ERC721
     */
    async getApproved(tokenId) {
        var _a;
        const res = await this.swapMulticall.useSingleCallResult(this.contract, "getApproved", [tokenId]);
        return (_a = res === null || res === void 0 ? void 0 : res.result) === null || _a === void 0 ? void 0 : _a[0];
    }
    async isApprovedForAll(owner, operator) {
        var _a;
        const res = await this.swapMulticall.useSingleCallResult(this.contract, "isApprovedForAll", [owner, operator]);
        return (_a = res === null || res === void 0 ? void 0 : res.result) === null || _a === void 0 ? void 0 : _a[0];
    }
    async name() {
        var _a;
        const res = await this.swapMulticall.useSingleCallResult(this.contract, "name");
        return (_a = res === null || res === void 0 ? void 0 : res.result) === null || _a === void 0 ? void 0 : _a[0];
    }
    async owner() {
        var _a;
        const res = await this.swapMulticall.useSingleCallResult(this.contract, "owner");
        return (_a = res === null || res === void 0 ? void 0 : res.result) === null || _a === void 0 ? void 0 : _a[0];
    }
    async ownerOf(tokenId) {
        var _a;
        const res = await this.swapMulticall.useSingleCallResult(this.contract, "ownerOf", [tokenId]);
        return (_a = res === null || res === void 0 ? void 0 : res.result) === null || _a === void 0 ? void 0 : _a[0];
    }
    async renounceOwnership() {
        var _a;
        const result = await ((_a = this.contract) === null || _a === void 0 ? void 0 : _a.renounceOwnership({
            from: this.account
        }));
        return result;
    }
    async safeTransferFrom(from, to, tokenId) {
        var _a;
        const result = await ((_a = this.contract) === null || _a === void 0 ? void 0 : _a["safeTransferFrom(address,address,uint256)"](from, to, tokenId, {
            from: this.account
        }));
        return result;
    }
    async safeTransferFromWithData(from, to, tokenId, data) {
        var _a;
        const result = await ((_a = this.contract) === null || _a === void 0 ? void 0 : _a["safeTransferFrom(address,address,uint256,bytes)"](from, to, tokenId, data, {
            from: this.account
        }));
        return result;
    }
    async setApprovalForAll(operator, approved) {
        var _a;
        const result = await ((_a = this.contract) === null || _a === void 0 ? void 0 : _a.setApprovalForAll(operator, approved, {
            from: this.account
        }));
        return result;
    }
    async supportsInterface(interfaceId) {
        return await this.swapMulticall.useSingleCallResult(this.contract, "supportsInterface", [interfaceId]);
    }
    async symbol() {
        var _a;
        const res = await this.swapMulticall.useSingleCallResult(this.contract, "symbol");
        return (_a = res === null || res === void 0 ? void 0 : res.result) === null || _a === void 0 ? void 0 : _a[0];
    }
    /**
     * 根据index获取tokenId
     *
     * @param {number} index
     * @returns {Promise<number>} token id
     * @memberof ERC721
     */
    async tokenByIndex(index) {
        var _a;
        const res = await this.swapMulticall.useSingleCallResult(this.contract, "tokenByIndex", [index]);
        return (_a = res === null || res === void 0 ? void 0 : res.result) === null || _a === void 0 ? void 0 : _a[0].toNumber();
    }
    /**
     * 根据指定钱包地址index获取tokenId
     *
     * @param {number} index
     * @returns {Promise<number>} token id
     * @memberof ERC721
     */
    async tokenOfOwnerByIndex(owner, index) {
        var _a;
        const res = await this.swapMulticall.useSingleCallResult(this.contract, "tokenOfOwnerByIndex", [owner, index]);
        return (_a = res === null || res === void 0 ? void 0 : res.result) === null || _a === void 0 ? void 0 : _a[0].toNumber();
    }
    async tokenURI(tokenId) {
        var _a;
        const res = await this.swapMulticall.useSingleCallResult(this.contract, "tokenURI", [tokenId]);
        return (_a = res === null || res === void 0 ? void 0 : res.result) === null || _a === void 0 ? void 0 : _a[0];
    }
    async totalSupply() {
        const res = await this.swapMulticall.useSingleCallResult(this.contract, "totalSupply");
        const result = res.result;
        return result === null || result === void 0 ? void 0 : result[0].toNumber();
    }
    async transferAdministrator(newAdmin) {
        var _a;
        const result = await ((_a = this.contract) === null || _a === void 0 ? void 0 : _a.transferAdministrator(newAdmin, {
            from: this.account
        }));
        return result;
    }
    async transferFrom(from, to, tokenId) {
        var _a;
        const result = await ((_a = this.contract) === null || _a === void 0 ? void 0 : _a.transferFrom(from, to, tokenId, {
            from: this.account
        }));
        return result;
    }
    async transferOwnership(newOwner) {
        var _a;
        const result = await ((_a = this.contract) === null || _a === void 0 ? void 0 : _a.transferOwnership(newOwner, {
            from: this.account
        }));
        return result;
    }
    /**
     * 铸币
     * onlyOwner
     *
     * @param {string} receiver
     * @param {number} tokenId
     * @returns
     * @memberof ERC721
     */
    async mint(receiver, tokenId) {
        var _a;
        const result = await ((_a = this.contract) === null || _a === void 0 ? void 0 : _a.mint(tokenId, receiver, {
            from: this.account
        }));
        return result;
    }
    async burn(tokenId) {
        var _a;
        const result = await ((_a = this.contract) === null || _a === void 0 ? void 0 : _a.burn(tokenId, {
            from: this.account
        }));
        return result;
    }
    async reBaseUri(uri) {
        var _a;
        const result = await ((_a = this.contract) === null || _a === void 0 ? void 0 : _a.reBaseUri(uri, {
            from: this.account
        }));
        return result;
    }
}
exports.default = ERC721;
